import { OpenAIApi, Configuration } from "openai";
const configuration = new Configuration({
  apiKey: process.env.REACT_APP_OPEN_AI,
});

const openai = new OpenAIApi(configuration);

let prevResult: any;

export const openAIgenerateImage = async (text: string) => {
  // return image.imageBase64;

  const response = await openai.createImage({
    prompt: text,
    n: 1,
    size: "512x512",
    response_format: "b64_json",
  });
  const b64_json = response.data.data[0].b64_json;
  prevResult = b64_json;
  return b64_json;
};

export const openAIgenerateImageVariation = async (file: File) => {
  const response = await openai.createImageVariation(
    // @ts-ignore
    file,
    1,
    "512x512",
    "b64_json"
  );

  const b64_json = response.data.data[0].b64_json;
  prevResult = b64_json;
  return b64_json;
};
